import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetAll } from '../../../../shared/infra/redux/baseActions';
import { ReduxStatus } from '../../../../shared/types';
import { uploadCoverImage, uploadDocument, uploadLogoImage } from './operators';

export interface FileState {
  fileUploadStatus: {
    status: ReduxStatus;
    error: string | null;
  };
  percentageUploaded: number;
}

const initialState: FileState = {
  fileUploadStatus: {
    status: 'idle',
    error: null,
  },
  percentageUploaded: 0,
};

const fileSlice = createSlice({
  name: 'files',
  initialState,
  reducers: {
    updateProgress: (state, action: PayloadAction<number>) => {
      state.percentageUploaded = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(uploadCoverImage.pending, (state) => {
      state.fileUploadStatus = {
        status: 'loading',
        error: null,
      };
      state.percentageUploaded = 0;
    });
    builder.addCase(uploadCoverImage.fulfilled, (state) => {
      state.fileUploadStatus = {
        status: 'success',
        error: null,
      };
      state.percentageUploaded = 0;
    });
    builder.addCase(uploadCoverImage.rejected, (state, { payload }) => {
      state.fileUploadStatus = {
        status: 'failure',
        error: payload?.message
          ? payload.message
          : 'Error trying to upload cover image',
      };
    });
    builder.addCase(uploadLogoImage.pending, (state) => {
      state.fileUploadStatus = {
        status: 'loading',
        error: null,
      };
    });
    builder.addCase(uploadLogoImage.fulfilled, (state) => {
      state.fileUploadStatus = {
        status: 'success',
        error: null,
      };
      state.percentageUploaded = 0;
    });
    builder.addCase(uploadLogoImage.rejected, (state, { payload }) => {
      state.fileUploadStatus = {
        status: 'failure',
        error: payload?.message
          ? payload.message
          : 'Error trying to upload cover image',
      };
    });
    builder.addCase(uploadDocument.pending, (state) => {
      state.fileUploadStatus = {
        status: 'loading',
        error: null,
      };
      state.percentageUploaded = 0;
    });
    builder.addCase(uploadDocument.fulfilled, (state) => {
      state.fileUploadStatus = {
        status: 'success',
        error: null,
      };
      state.percentageUploaded = 0;
    });
    builder.addCase(uploadDocument.rejected, (state, { payload }) => {
      state.fileUploadStatus = {
        status: 'failure',
        error: payload?.message
          ? payload.message
          : 'Error trying to upload document',
      };
    });
    builder.addCase(resetAll, () => initialState);
  },
});

export const { updateProgress } = fileSlice.actions;

export default fileSlice.reducer;
